import React, { useEffect, useState } from 'react';
import { Table, Form, Button, Row, Col, Card, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FaUserCircle, FaBoxOpen } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import { useProfileMutation } from '../slices/usersApiSlice';
import { useGetMyOrdersQuery } from '../slices/ordersApiSlice';
import { setCredentials } from '../slices/authSlice';

const ProfileScreen = () => {
    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.auth);

    /* PROFILE STATE */
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    /* ORDERS STATE */
    const { data: orders = [], isLoading, error } = useGetMyOrdersQuery();
    
    const [updateProfile, { isLoading: loadingUpdate }] = useProfileMutation();
    const isUnchanged = name === userInfo.name && email === userInfo.email && !password;

    useEffect(() => {
        if (userInfo) {
        setName(userInfo.name);
        setEmail(userInfo.email);
        }
    }, [userInfo]);

    /* PROFILE SUBMIT */
    const submitHandler = async (e) => {
        e.preventDefault();

        if (password && password !== confirmPassword) {
        toast.error('Wachtwoorden komen niet overeen');
        return;
        }

        try {
        const res = await updateProfile({ name: name.trim(), email: email.trim(), password }).unwrap();
        dispatch(setCredentials(res));
        toast.success('Profiel bijgewerkt');
        setPassword('');
        setConfirmPassword('');
        } catch (err) {
        toast.error(err?.data?.message || err.error);
        }
    };

    return (
        <>
            <Row className="g-4">
                {/* MIJN PROFIEL */}
                <Col md={4} sm={12}>
                    <Card className="shadow-sm border-0 h-100">
                        <Card.Body>
                        <h4 className="mb-4 d-flex align-items-center gap-2">
                            <FaUserCircle /> Mijn Profiel
                        </h4>

                        <Form onSubmit={submitHandler}>
                            <Form.Group className="mb-3">
                            <Form.Label>Naam</Form.Label>
                            <Form.Control value={name} onChange={(e) => setName(e.target.value)} />
                            </Form.Group>

                            <Form.Group className="mb-3">
                            <Form.Label>E-mail</Form.Label>
                            <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} />
                            </Form.Group>

                            <Form.Group className="mb-3">
                            <Form.Label>Nieuw wachtwoord</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Laat leeg om niet te wijzigen"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            </Form.Group>

                            <Form.Group className="mb-4">
                            <Form.Label>Bevestig wachtwoord</Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            </Form.Group>

                            <Button type="submit" className="w-100" disabled={isUnchanged}>
                                Profiel bijwerken
                            </Button>

                            {loadingUpdate && <Loader />}
                        </Form>
                        </Card.Body>
                    </Card>
                </Col>

                {/* MIJN BESTELLINGEN */}
                <Col md={8} sm={12}>
                    <Card className="shadow-sm border-0">
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="d-flex align-items-center gap-2 mb-0">
                                <FaBoxOpen /> Mijn Bestellingen
                                <Badge bg="secondary">{orders.length}</Badge>
                            </h4>
                            </div>

                            {isLoading ? (
                            <Loader />
                            ) : error ? (
                            <p>Fout bij het ophalen van bestellingen</p>
                            ) : orders.length === 0 ? (
                            <p>Geen bestellingen gevonden</p>
                            ) : (
                            <Table size="sm" hover responsive>
                                <thead>
                                <tr>
                                    <th>Datum</th>
                                    <th>Totaal</th>
                                    <th>Betaald</th>
                                    <th>Ontvangen</th>
                                </tr>
                                </thead>
                                <tbody>
                                {orders.slice(0, 5).map((o) => (
                                    <tr key={o._id}>
                                    <td>{o.createdAt.substring(0, 10)}</td>
                                    <td>€ {o.itemsPrice.toFixed(2)}</td>
                                    <td>{o.isPaid ? <Badge bg="success">Ja</Badge> : <Badge bg="danger">Nee</Badge>}</td>
                                    <td>{o.isDelivered ? <Badge bg="success">Ja</Badge> : <Badge bg="danger">Nee</Badge>}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                            )}
                            {orders.length > 5 && <small>Alle bestellingen zijn te bekijken op de Mijn Bestellingen pagina</small>}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default ProfileScreen;